import { render, staticRenderFns } from "./ConnectionSustainabilityScore.vue?vue&type=template&id=3d8a5eac&scoped=true"
import script from "./ConnectionSustainabilityScore.vue?vue&type=script&lang=js"
export * from "./ConnectionSustainabilityScore.vue?vue&type=script&lang=js"
import style0 from "./ConnectionSustainabilityScore.vue?vue&type=style&index=0&id=3d8a5eac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8a5eac",
  null
  
)

export default component.exports